/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Ups_Booking_Failed_GenericInputs */

const en_orders_ups_booking_failed_generic = /** @type {(inputs: Orders_Ups_Booking_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to book UPS shipments`)
};

const es_orders_ups_booking_failed_generic = /** @type {(inputs: Orders_Ups_Booking_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo reservar UPS`)
};

/**
* | output |
* | --- |
* | "Failed to book UPS shipments" |
*
* @param {Orders_Ups_Booking_Failed_GenericInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_ups_booking_failed_generic = /** @type {((inputs?: Orders_Ups_Booking_Failed_GenericInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Ups_Booking_Failed_GenericInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_ups_booking_failed_generic(inputs)
	return es_orders_ups_booking_failed_generic(inputs)
});